import React from 'react';
import Relay from 'react-relay';
import DatePicker from 'react-bootstrap-date-picker';
import Select from 'react-select';
import EditSportunity from './EditCircle';
import SportunitiesList from './CirclesList';

import Button from '../../components/Button';

import { isValidEmailAddress } from '../../components/UserPanel'

const getOptionsFromSports = (sports) => sports && sports.edges.map((edge) => ({
  value: edge.node.id, label: edge.node.name.EN,
}))

export const getOptionsFromUsers = (users) => users && users.edges.length && users.edges.map((edge) => ({
  value: edge.node.pseudo, label: edge.node.pseudo, user: edge.node,
}))

const circlesModeOptions = [{
  value: 'PUBLIC',
  label: 'Public',
}, {
  value: 'PRIVATE',
  label: 'Private',
}]

class CirclesPage extends React.Component {

  state = {
    currentFilter: '',
    searchBySport: {},
    searchByOrganizeId: null,
    searchByPublicKind: null,
    selectLevels: null,
  }

  _onButtonClick() {
    let {that, text} = this.props;
    that.setState({
        currentFilter: text
    });

    let path = '/circles/list/'+text.toLowerCase();
    that.props.router.push({
        pathname : path,
        state :{
            filter : text,
        }
    });
}
  _renderFilterButton(filterName, index) {
    let color = 'btn-default';

    if (filterName == this.state.currentFilter) {
      color = 'btn-danger';
    }

    return <Button
              text={filterName}
              key={index}
              that={this}
              color={color}
              onClick={this._onButtonClick}
            />
  }

  _renderChildren = () =>
  React.Children.map(this.props.children, child =>
    React.cloneElement(child, {
      ...this.props
    })
  )

  render() {
    let filters = ["All"];
    return (
      <div>
            <div style={{ marginTop: 20, marginBottom: 20, display: 'flex', flexDirection: 'row' }}>
                {filters.map((filterName, index) => this._renderFilterButton(filterName, index))}
            </div>
            {this._renderChildren()}
      </div>
    );
  }
}

const styles = {
  input: {
    borderRadius: 20,
    padding: 5,
    minWidth: 250,
  },
  sportSelectContainer: {
    display: 'inline-block',
    marginLeft: 15,
    minWidth: 200,
    height: 26,
  },
}


export default Relay.createContainer(CirclesPage, {
  initialVariables: {
    pseudo_autocomplete: null,
    email_autocomplete: null,
    autocompletion_required: false,
    querySports: false
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        id

        sports(first: 1000) @include(if: $querySports) {
          edges {
            node {
              id
              name {
                EN
              }
              levels {
                id
                EN {
                  name
                }
              }
            }
          }
        }

        autocompleteUsers: users (pseudo: $pseudo_autocomplete, email: $email_autocomplete, last: 5) @include(if: $autocompletion_required) {
          edges {
            node {
              id
              pseudo
              avatar
            }
          }
        }
      }
    `,
  }
})



// WEBPACK FOOTER //
// ./src/pages/Circle/CirclesPage.js